import type { ProjectScope } from './project-scope';

const pendingFeedPostWriteKeys = new Set<string>();
const pendingFeedCommentWriteKeys = new Set<string>();
const pendingFeedReactionWriteKeys = new Set<string>();

function feedWriteKey(scope: ProjectScope, id: string): string {
    return `${scope.orgId}/${scope.projectId}/${id}`;
}

export function markPendingFeedPostWrite(scope: ProjectScope, postId: string): void {
    pendingFeedPostWriteKeys.add(feedWriteKey(scope, postId));
}

export function clearPendingFeedPostWrite(scope: ProjectScope, postId: string): void {
    pendingFeedPostWriteKeys.delete(feedWriteKey(scope, postId));
}

export function isPendingFeedPostWrite(scope: ProjectScope, postId: string): boolean {
    return pendingFeedPostWriteKeys.has(feedWriteKey(scope, postId));
}

export function markPendingFeedCommentWrite(scope: ProjectScope, commentId: string): void {
    pendingFeedCommentWriteKeys.add(feedWriteKey(scope, commentId));
}

export function clearPendingFeedCommentWrite(scope: ProjectScope, commentId: string): void {
    pendingFeedCommentWriteKeys.delete(feedWriteKey(scope, commentId));
}

export function isPendingFeedCommentWrite(scope: ProjectScope, commentId: string): boolean {
    return pendingFeedCommentWriteKeys.has(feedWriteKey(scope, commentId));
}

export function markPendingFeedReactionWrite(scope: ProjectScope, reactionId: string): void {
    pendingFeedReactionWriteKeys.add(feedWriteKey(scope, reactionId));
}

export function clearPendingFeedReactionWrite(scope: ProjectScope, reactionId: string): void {
    pendingFeedReactionWriteKeys.delete(feedWriteKey(scope, reactionId));
}

export function isPendingFeedReactionWrite(scope: ProjectScope, reactionId: string): boolean {
    return pendingFeedReactionWriteKeys.has(feedWriteKey(scope, reactionId));
}

export function clearPendingFeedWrites(): void {
    pendingFeedPostWriteKeys.clear();
    pendingFeedCommentWriteKeys.clear();
    pendingFeedReactionWriteKeys.clear();
}
